export const DRAWER_START_EXPAND = 'SAGE_DRAWER_START_EXPAND';
export const DRAWER_END_EXPAND = 'SAGE_DRAWER_END_EXPAND';
export const DRAWER_START_COLLAPSE = 'SAGE_DRAWER_START_COLLAPSE';
export const DRAWER_END_COLLAPSE = 'SAGE_DRAWER_END_COLLAPSE';
